import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_entity_branch_hdr_RowClass } from '../../dbschema/bl_fi_mst_entity_branch_hdr.model';

export class IntercompanyBranchContainerModel extends BaseContainerModel{
    bl_fi_mst_entity_branch_hdr: bl_fi_mst_entity_branch_hdr_RowClass = new bl_fi_mst_entity_branch_hdr_RowClass();   
}
